var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixSocialGroupsV2GroupRole from '@wix/ambassador-social-groups-v2-group-role/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Regular group member. */
    Role["MEMBER"] = "MEMBER";
    /** Group administrator. */
    Role["ADMIN"] = "ADMIN";
})(Role || (Role = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _assignRoleRequest = {};
const _assignRoleResponse = {};
const _unassignRoleRequest = {};
const _unassignRoleResponse = {};
/**
 * Assigns a specific role to group members.
 *
 *
 * >**Note:** This function is only relevant for site admins, and group members with group admin permissions.
 *
 * The `assignRole()` function returns a Promise that resolves to the newly-assigned role after it has successfully been assigned. Assigning a role overrides an existing role. For example, assigning a member role to an admin unassigned their admin role.
 * @param groupId - Group ID.
 * @param memberIds - Member IDs.
 *
 * Max: 100 member IDs
 * @param role - Role to assign.
 * @public
 * @requiredField groupId
 * @requiredField memberIds
 * @requiredField role
 * @adminMethod
 */
export function assignRole(groupId, memberIds, role, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            memberIds: '$[1]',
            role: '$[2]',
            siteMemberIds: '$[3].siteMemberIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[4];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _assignRoleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['role']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _assignRoleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['role']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, memberIds, role, options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRole.assignRole(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'memberIds',
                'role',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Unassigns a role from group members.
 *
 * >**Note:** This function is only relevant for site admins, and group members with group admin permissions.
 *
 * The `unassignRole()` function returns a Promise that resolves to the unassigned role after it has successfully been unassigned. This function only applies to admin roles. Using this function with member roles returns an error.
 * @param groupId - Group ID.
 * @param memberIds - Member IDs.
 *
 * Max: 100 member IDs
 * @param role - Role to unassign.
 * @public
 * @requiredField groupId
 * @requiredField memberIds
 * @requiredField role
 * @adminMethod
 */
export function unassignRole(groupId, memberIds, role, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            memberIds: '$[1]',
            role: '$[2]',
            siteMemberIds: '$[3].siteMemberIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[4];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _unassignRoleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['role']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _unassignRoleResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['role']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, memberIds, role, options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRole.unassignRole(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'memberIds',
                'role',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=social-groups-v2-group-role.universal.js.map